import { PROCESS } from 'src/shared/constants/constants'
import { Option } from 'src/shared/form/control'
import { CRITERIA_TYPE } from 'src/shared/constants/assessment-constants'
import {
  getTranslationForCriteriaType,
  getTranslationForProcess,
} from 'src/screens/administration/configuration-management/ConfigurationUtils'

/**
 * Builds criteria type options for select components.
 * Used in both grid filters (no translation needed) and forms (translation required).
 * @param getMessage - Optional translation function for form labels
 */
export const getCriteriaTypeOptions = (
  getMessage: (key: string, params?: Array<string | number>) => string,
): Option[] => {
  return Object.values(CRITERIA_TYPE).map((cType) => ({
    label: getTranslationForCriteriaType(getMessage, cType),
    value: cType,
  }))
}

/**
 * Builds process options for configuration form selects.
 * @param getMessage - Translation function for process labels
 */
export const getCriteriaConfigProcessOptions = (
  getMessage: (key: string, params?: Array<string | number>) => string,
): Option[] => {
  return CRITERIA_CONFIG_PROCESSES.map((process) => ({
    label: getTranslationForProcess(getMessage, process),
    value: process,
  }))
}

const CRITERIA_CONFIG_PROCESSES = [PROCESS.PF_KAP, PROCESS.PF_PGV, PROCESS.FACTSHEET]

export { CRITERIA_CONFIG_PROCESSES }
